import { ImageProps } from '@/components/shared/media/image/Image.props';

export const NOT_FOUND_IMAGE: ImageProps = {
  src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb5cc3b7e4793ab2f/628b54836f81705517a1d8e0/not-found.svg',
  alt: 'not-found',
  width: 373,
  height: 273,
};
